"use client"
import { useState } from "react"

export const CopyButton = ({ text }: { text: string }) => {
    const [isCopied, setIsCopied] = useState(false)

    const copy = async () => {
        await navigator.clipboard.writeText(text)
        setIsCopied(true);

        setTimeout(() => {
            setIsCopied(false);
        }, 10000)
    }

    return (
        <button
            disabled={isCopied}
            onClick={copy}
            className="text-xs text-light/80 border-light/60 md:text-sm border hover:brightness-125 disabled:hover:brightness-100 rounded-md px-2 md:px-2.5 py-0.5"
            name="Copy"
            aria-label="Copy"
        >
            {isCopied ? "Copied!" : "Copy"}
        </button>
    )
}